import { render, staticRenderFns } from "./TwMentionList.vue?vue&type=template&id=ab0672dc&"
import script from "./TwMentionList.vue?vue&type=script&lang=js&"
export * from "./TwMentionList.vue?vue&type=script&lang=js&"
import style0 from "./TwMentionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports